import { React } from '@common/3rd';
import { PageComponents, StyledProps, QRCodeGeneratorFunc, QRCodeGeneratorLib, ButtonType } from '@my-types';
import { Styled, QRCodeGenerator } from '@common/3rd';
import { Page } from '@component';
import { DeskButton, DeskPanel } from '@desk-component';
import DeskPageBody from './desk-page-body';
import DeskPageHeader from './desk-page-header';
import DeskPageFooter from './desk-page-footer';
import { Envs, Utils, Apis, PATH, Ajax, Storage } from '@common';
import { Checker } from '@model';
import { CheckRuleOptions } from '@my-types';
import { cardBg1, cardBg2, cardBg3, keepCheckFieldInAccount } from '../../const';
import Alert from '@alert';
import Dialog from '@dialog';
import { useState, useRef, useEffect } from 'react';
import Captcha from '@component/captcha';
import { StyledComponents } from '@styles';


const MOBILE_DESK_VENDOR_PATH_MAP = new Map([
	[PATH.DESK2_HOME_VENDOR, '/csms2/mall/home/:vendor'],
	[PATH.DESK2_PRODUCT_MAIN_VENDOR, '/csms2/mall/product/:vendor'],
	[PATH.DESK2_ABOUT_US_VENDOR, '/csms2/mall/about-us/:vendor'],
	[PATH.DESK2_DISCLOSURE_MAIN_VENDOR, '/csms2/mall/disclosure/:vendor'],
	[PATH.DESK2_HELP_VENDOR, '/csms2/mall/help/:vendor'],
])


/**
 * 桌面页面
 */
class DeskPage<P, S, C extends PageComponents> extends Page<P, S & any, C> {
	tenantCode?: string;
	tenantId?: number;
	timer: any;
	_vendor: string;
	constructor(props: any, context?: any) {
		super(props, context);
		this._vendor = this.getVendorFromProps(props);
		this.state = {
			headerKey: 0
		};
		// TODO: 根据url判断租户code 开发环境默认为美世租户  未登录情况下tenantCode和tenantId从哪来？
		if (window.location.host.includes('mej') || process.env.NODE_ENV === 'development') {
			document.title = '美世美e佳';
			this.tenantCode = 'MEJ';
			let iconLink = document.querySelectorAll('[rel="icon"]')[0];
			// @ts-ignore
			iconLink.href = `${process.env.REACT_APP_AJAX_CLIENT_CONTEXT}/pc/mej.ico`;
		}
		this.handleNotDeskVendorPath(props);
	}
	// mej跳转
	protected handleNotDeskVendorPath(props: any) {
        if (!Envs.isDesk() && (window.location.host.includes('mej') || process.env.NODE_ENV === 'development')) {
			console.log('handleNotDeskVendorPath', this.props)
			console.log('props', props)
			console.log('props', this._vendor)
            let path = props?.path;
            let mobilePath = MOBILE_DESK_VENDOR_PATH_MAP.get(path);
            let vendor = encodeURIComponent(decodeURIComponent(this._vendor || ''));
            if (path && mobilePath && vendor) {
				let vendor_mobilePath = mobilePath.replace(':vendor', vendor);
                let mobileUrl = window.location.origin + vendor_mobilePath;
                if (window.location.href.split('?')[1]) {
                    mobileUrl += `?${window.location.href.split('?')[1]}`;
                }
                console.log('vendor_mobilePath', vendor_mobilePath);
                console.log('mobileUrl', mobileUrl);
                window.location.replace(mobileUrl);
            }
        }
    }
	protected initComponents(): C {
		const C = super.initComponents();
		return Object.assign(C, {
			Box: Styled(C.Box).attrs({
				'data-widget': 'desk-page'
			})`
				font-family: 'PingFangSC-Regular', 'PingFang SC', sans-serif;
				color: #0A0D2B;
				background-color: #F9F9F9;
				input::placeholder,
				textarea::placeholder {
					// opacity: 0.5;
					color: #ccc;
				}
				.swiper-button-prev, .swiper-button-next {
					display: none;
				}
				.swiper-pagination-bullet {
					width: 12px;
					height: 6px;
					border-radius: 6px;
					background: #fff;
					opacity: 1;
					&.swiper-pagination-bullet {
						background: ${props => props.theme.COLOR_DISABLED};
					}
					&.swiper-pagination-bullet-active {
						background: ${props => props.theme.COLOR_SUCCESS};
					}
				}
			`,
			ContentWrapper: Styled.div`
				display: flex;
				flex-wrap: wrap;
				justify-content: space-between;
				width: 1110px;
				margin: 0 auto;
				margin-top: 20px;
				&:after {
					content: '';
					flex: auto;
				}
				> .title {
					margin-bottom: 20px;
					width: 100%;
					display: flex;
					justify-content: space-between;
					color: #0A0D2B;
					span {
						font-size: 32px;
						font-weight: 400;
					}
					i {
						font-style: normal;
						color: ${props => props.theme.COLOR_SUCCESS};
					}
				}
				.top-swiper {
					line-height: 1;
				}
				.bottom-swiper-wrapper {
					width: 100%;
					height: 160px;
					padding: 30px 50px;
					box-shadow: 1px 1px 10px #ddd;
					border-radius:${props => props.theme.BORDER_RADIUS_LARGE}px;
					position: relative;
					&:before, &:after {
						content: '';
						display: block;
						position: absolute;
						width: 120px;
						z-index: 2;
					}
					&:before {
						top: 0; left: 0; bottom: 0;
						background: linear-gradient(to right,#fff 40%,transparent 100%);
					}
					&:after {
						top: 0; right: 0; bottom: 0;
						background: linear-gradient(to left,#fff 40%,transparent 100%);
					}
				}
				.img-swiper {
					line-height: 1;
					position: relative;
					.swiper-slide {
						width: 200px;
						height: 96px;
					}
				}
				a:not([data-widget="desk-btn"]):not([data-widget="desk-pagination-button"]) {color: ${props => props.theme.COLOR_SUCCESS};}
				.link {
					font-size: 14px;
					cursor: pointer;
					color: ${props => props.theme.COLOR_SUCCESS};
				}
				.block {
					width: 100%;
				}
				${(props: StyledProps) => (props.css ? props.css(props, (props as any).theme) : '')}
			`,
			Premium: Styled.div.attrs({
				'data-widget': 'product-premium'
			})`
				// color: ${props => props.theme.COLOR_PRIMARY};
				color: #AC7B0E;
				line-height: 1;
				span:first-child {
					font-weight: 600;
					font-size: 24px;
					padding-right: 5px;
				}
				span:not(:first-child) {
					// color: ${props => props.theme.FONT_COLOR};
					color: #818498;
					font-size: 14px;
				}
				${(props: StyledProps) => (props.css ? props.css(props, (props as any).theme) : '')}
			`,
			SupTip: Styled.div.attrs({
				'data-widget': 'sup-tip'
			})`
				position: absolute;
				top: 0;
				left: 0;
				width: 82px;
				height: 22px;
				font-size: 14px;
				line-height: 22px!important;
				background: #DDC594;
				// background: linear-gradient(135deg, rgba(53,150,145,1) 0%, rgba(70,200,200,1) 100%);
				text-align: center;
				font-weight: 400;
				border-radius: 10px 0px 10px 0px;
			`,
			Overall: Styled.div.attrs({
				'data-widget': 'overall'
			})`
				position: absolute;
				z-index: 10;
				left: 0;
				right: 0;
				bottom: 0;
				background: rgba(0, 0, 0, .5);
				transition: all .1s ease-in;
				display: flex;
				justify-content: center;
				align-items: center;
				top: 100%;
				text-align: center;
				padding: 10px;
				p {
					display: none;
					font-size: 12px;
					line-height: 1.2;
					color: #fff;
					// font-weight: bold;
				}
				&.show {
					top: 0;
					img {
						width: 160px;
						height: 160px;
						background: #fff;
						padding: 10px;
						border-radius: 6px;
					}
					p {
						display: block;
					}
				}
			`,
			Product: Styled.div.attrs({
				'data-widget': 'product-wrapper'
			})`
				width: 540px;
				// height: 200px;
				background: #fff;
				box-shadow: 0px 0px 20px 0px rgba(0,0,0,0.05);
				display: flex;
				cursor: pointer;
				overflow: hidden;
				border-radius: ${props => props.theme.BORDER_RADIUS_LARGE}px;
				margin-bottom: 18px;
				position: relative;
				line-height: initial;
				&:nth-child(even) {
					margin-right: 30px;
				}
				&:hover {
					img:not(.qrcode) {
						transform: scale(1.1);
					}
					[data-widget="desk-btn"] {
						background: #d0503d;
					}
				}
				> div:first-child {
					width: 200px;
					height: 100%;
					overflow: hidden;
					position: relative;
					> img {
						width: 100%;
						transition: all .2s ease-in-out;
						display: block;
					}
				}
				> div:not(:first-child):not([data-widget='sup-tip']) {
					padding: 10px 30px 60px;
					// flex: 1;
					width: calc(100% - 200px);
					position: relative;
					.item-title {
						font-size: 20px;
						font-weight: 600;
						line-height: 28px;
					}
					.item-vendor {
						display: inline-block;
						font-size: 12px;
						line-height: 20px;
						color: #000;
						background: #F5E7C9;
						padding: 0 5px;
						border-radius: 2px;
						margin: 5px 0;
					}
					.item-desc {
						font-size: 14px;
						line-height: 22px;
						color: #818498;
					}
					.item-premium {
						position: absolute;
						bottom: 15px; left: 30px; right: 20px;
						display: flex;
						justify-content: space-between;
						align-items: flex-end;
						[data-widget="desk-btn"] {
							padding: 0 22px;
							height: 36px;
							line-height: 36px;
							font-weight: 400;
						}
					}
				}
			`,
			Rank: Styled.div.attrs({
				'data-widget': 'product-rank'
			})`
				line-height: initial;
				padding-bottom: 40px;
				width: calc(33.3% - 16px);
				min-height: 210px;
				background-repeat: no-repeat;
				background-size: cover;
				display: flex;
				cursor: pointer;
				margin-right: 16px;
				overflow: hidden;
				border-radius: 8px;
				margin-bottom: 20px;
				position: relative;
				&:hover {
					img:not(.qrcode) {
						transform: scale(1.1);
					}
				}
				&:nth-child(3n + 1) {
					margin-right: 0;
					background-image: url(${cardBg1});
				}
				&:nth-child(3n + 2) {
					background-image: url(${cardBg2});
				}
				&:nth-child(3n + 3) {
					background-image: url(${cardBg3});
				}
				> div:not([data-widget='overall']) {
					padding: 20px 18px;
					line-height: initial;
					> span {
						font-size: 20px;
						font-weight: 600;
					}
					.item-desc {
						margin-top: 8px;
						font-size: 16px;
						line-height: 24px;
					}
					.item-premium {
						position: absolute;
						bottom: 20px; left: 20px; right: 20px;
						display: flex;
						justify-content: space-between;
						align-items: flex-end;
						[data-widget="desk-btn"] {
							width: 94px;
							text-align: center;
							height: 30px;
							line-height: 30px;
							font-weight: 400;
							padding: 0;
    						border-radius: 22px;
							background-color: #CDA76E;
						}
					}
				}
			`,
			BottomLink: Styled.div`
				border: 1px solid ${props => props.theme.COLOR_SUCCESS};
				color: ${props => props.theme.COLOR_SUCCESS};
				text-align: center;
				padding: 0 20px;
    			border-radius: 40px;
			`,
			Classification: Styled.div`
				width: 100%;
				display: flex;
				text-align: center;
				align-items: center;
				border-radius:${props => props.theme.BORDER_RADIUS_LARGE}px;
				height: 40px;
				line-height: 40px;
				> span {
					width: 56px;
					text-align: right;
				}
				> div{
					cursor: pointer;
					border: 1px solid ${props => props.theme.BORDER_COLOR_MINOR_LIGHT};
					background: ${props => props.theme.COLOR_BACKGROUND};
					line-height: 30px;
					height: 30px;
					border-radius: 30px;
					margin-right: 30px;
					padding: 0 15px;
					min-width: 80px;
					font-size: 14px;
    				color: #818498;
					position: relative;

					display: flex;
					align-items: center;
					justify-content: center;

					&.active {
						background: ${props => props.theme.COLOR_SUCCESS};
						color: #fff;
					}
					.fa-caret-up, .fa-caret-down {
						font-size: 12px;
						position: absolute;
						right: 12px;
						opacity: .5;
						&.active {
							opacity: 1;
						}
					}
					.fa-caret-up {
						bottom: 10px;
					}
					.fa-caret-down {
						top: 12px;
					}

					&.not-button{
						display: flex;
						padding:0px;
						margin-right: 0px;
						border:none;
						justify-content: center;
						background: transparent;
						color: #0A0D2B;
					}
				}
				${(props: StyledProps) => (props.css ? props.css(props, (props as any).theme) : '')}
			`,
			TargetGroupClassification: Styled.div`
				width: 100%;
				display: flex;
				text-align: center;
				align-items: center;
				border-radius:${props => props.theme.BORDER_RADIUS_LARGE}px;
				height: 40px;
				line-height: 40px;
				> div:nth-child(1) {
					white-space: nowrap;
					position: relative;
					display: flex;
					align-items: center;

					> div:first-child{
						width:80px;
					}
			
					> div:not(:first-child){

						display: flex;
						align-items: center;
						justify-content: center;

						cursor: pointer;
						border: 1px solid ${props => props.theme.BORDER_COLOR_MINOR_LIGHT};
						background: ${props => props.theme.COLOR_BACKGROUND};
						line-height: 30px;
						height: 30px;
						border-radius: 30px;
						margin-right: 30px;
						padding: 0 15px;
						min-width: 80px;
						font-size: 14px;
						color: #818498;
						position: relative;
			
						&.active {
							background: ${props => props.theme.COLOR_SUCCESS};
							color: #fff;
						}
					}
			
					&:last-child {
						margin: 0;
					}
			
				}
				${(props: StyledProps) => (props.css ? props.css(props, (props as any).theme) : '')}
			`,
			Table: Styled.div<{ gridTemplateColumns: string, count: number }>`
				display: grid;
				grid-template-columns: ${props => props.gridTemplateColumns};
				border: 1px solid ${props => props.theme.BORDER_COLOR_MINOR_LIGHT};
				border-bottom: 0;
				align-items: center;
				width: 100%;
				color: #000;
				// text-align: center;
				${(props: StyledProps) => (props.css ? props.css(props, (props as any).theme) : '')}
				&:not(:first-child) {
					border-top: 0;
				}
				> div {
					line-height: 1.2;
					padding: 20px;
					height: 100%;
					border-bottom: 1px solid ${props => props.theme.BORDER_COLOR_MINOR_LIGHT};
					display: flex;
					flex-direction: column;
					justify-content: center;
					word-break: break-all;
				}
				&.table-title {
					background: ${props => props.theme.BORDER_COLOR_LIGHT};
					border-top: 1px solid ${props => props.theme.BORDER_COLOR_MINOR_LIGHT};
					border-bottom: 0;
					font-weight: bold;
					> div {
						padding: 20px;
						line-height: 1.2;
					}
				}
				& > div:not(:nth-child(${props => props.count}n + 1)) {
					border-left: 1px solid ${props => props.theme.BORDER_COLOR_MINOR_LIGHT};
				}
			`
		}) as C;
	}
	protected reRenderHeader() {
		this.setState({
			headerKey: Math.random()
		});
	}
	protected getHtmlTitle(): string | null {
		return null;
	}
	renderPageHeader() {
		return <DeskPageHeader key={this.state.headerKey} vendor={this._vendor}/>;
	}
	renderPageBody() {
		return <DeskPageBody />;
	}
	renderPageFooter() {
		return <DeskPageFooter vendor={this._vendor}/>;
	}
	protected handleChange(event: React.FormEvent<HTMLInputElement>, fieldCheck?: { [propName: string]: any }) {
		const target = event.target as HTMLInputElement;
		let value = target.type === 'checkbox' ? target.checked : target.value;
		this.setState({ [target.name]: value }, () => {
			if (this.state.errorMsg[target.name] && fieldCheck) {
				this.onBlur(fieldCheck, target.name, {
					hideMsg: true
				});
			}
		});
	}
	protected customAlertHint = (msg: string) => {
		let alertBoxCSS = `
		top: 50vh!important;
		width: 250px!important;
		`
		if (window.location.href.includes('sign/in')) {
			alertBoxCSS = `
			top: 40vh!important;
			left: 440px!important;
			min-width: 165px!important;
			width: 165px!important;`
		}
		Alert.hint(msg, () => `
		[data-widget='alert-backdrop'] {
			display: none;
		}
		[data-widget="alert-box"] {
			${alertBoxCSS}
			padding: 10px;
			background: rgba(0, 0, 0, .7);
			[data-widget="fas"] {
				display: none;
			}
			[data-widget="alert-body"] {
				background: transparent;
				margin: 0;
				color: #fff;
			}
			[data-widget="alert-msg-line"] {
				margin: 0;
				text-align: center
			}
		}`);
	}
	protected onBlur = async (fieldCheck: { [propName: string]: any }, field: string, opts?: { [propName: string]: any }) => {
		let msg: any[] = [];
		msg = this.validate(fieldCheck, field);
		this.setState((prevState: { [propName: string]: any }) => {
			return {
				...prevState,
				errorMsg: {
					...prevState.errorMsg,
					[field]: msg
				}
			}
		}, () => {
			if (!opts?.hideMsg) {
				if (/sign\/in/.test(window.location.href)) { // TODO: 当前仅特殊处理登录报错
					if (this.state.errorMsg[field]?.length) {
						this.customAlertHint(this.state.errorMsg[field]);
					}
				}
			}
		});
	}
	protected validate = (fieldCheck: { [propName: string]: any }, key?: string) => {
		let errorMsg: any[] = [];
		try {
			let getFieldMsg = (field: string) => {
				return (fieldCheck[field].rule as any[]).reduce((msg, rule) => {
					let res;
					if (Utils.isFunction(rule.do)) {
						res = rule.do.call(this, {
							value: this.state[field],
							model: this.state,
							root: {},
							caller: this
						});
					} else {
						res = Checker.check({
							rule: rule,
							value: this.state[field],
							model: this.state,
							root: {},
							caller: this
						});
					}
					if (!msg) {
						if (!res) {
							msg += rule.msg + (rule.msg === '请输入' ? fieldCheck[field].name : '');
						} else if (Utils.isString(res)) {
							msg += (res.includes(fieldCheck[field].name) || res.includes('请输入') ? '' : fieldCheck[field].name) + res;
						}
					}
					return msg;
				}, '');
			}
			if (!key) {
				Object.keys(fieldCheck).forEach(async field => {
					await new Promise<void>(resolve => {
						let fieldMsg = getFieldMsg(field)
						if (fieldMsg.length) {
							errorMsg.push(`${fieldCheck[field].name}错误：${fieldMsg}`);
						}
						resolve();
					})
				})
			} else {
				let fieldMsg = getFieldMsg(key);
				if (fieldMsg.length) {
					errorMsg.push(fieldMsg);
				}
			}
		} catch (e) {
			console.log('validate error', e);
		} finally {
			return errorMsg;
		}
	}
	async handleMouseOver(item: { [propName: string]: any }, listName: string, isOrgan?: boolean) {
		// "category": "1", // 分类 1.产品 2.视频 3.其他 4.合作保司
		// "thirdUrl": "url", // 第三方链接，仅为category=2或category=3时传值
		if (isOrgan || item.category === '1') {
			let productInfo = item.productInfo || item || {};
			const account = Envs.findAccount();
			let model = {
				vendorCode: productInfo.vendorCode,
				productCode: productInfo.productCode,
				productVersion: productInfo.productVersion,
				productName: productInfo.productName,
				tenantCode: this.tenantCode || '',
				accountName: account.accountName || '',
				productUrl: Ajax.isAuthorized() ? PATH.MOBILE_POLICY_INFO_SHOW : PATH.MOBILE_POLICY_INFO_SHOW,
				logoImage: '',
				qrcodeSize: 400
			}
			//新需求:不展示二维码了使用弹出info页的新窗口
			const url = await this.startGenerateQrCode(model);
			this.openNewProductInfoWindow({ url });

			//item.qrcode = await this.startGenerateQrCode(model)
			// item.showOverall = true;
			// this.setState({
			// 	[listName]: this.state[listName]
			// });

		} else if ((item.category === '2' || item.category === '3') && item.thirdUrl && Utils.isValidHttpUrl(item.thirdUrl)) {
			if(item.thirdFlag === true ){
				Alert.ask('即将跳转外部链接').then(() => {
					window.open(item.thirdUrl, '_blank');
				});
			}else{
				window.open(item.thirdUrl, '_blank');
			}
		}
	}
	handleMouseLeave(item: { [propName: string]: any }, listName: string) {
		item.showOverall = false;
		item.qrcode = undefined;
		this.setState({
			[listName]: this.state[listName]
		});
	}

	getVendorFromProps(props: any) {
        let vendor = decodeURIComponent(props.vendor || '');
        if (!vendor) return '';
        return vendor.startsWith('{AES}') ? vendor : 'VENDOR_IS_INVALID';
    }

	openNewProductInfoWindow(options: { url: string; }) {
		const { url } = options;
		window.open(Envs.getContextLocation(`${PATH.DESK2_MOBILE_IFRAME}?${Utils.toQueryString({
			rootUrlFrom: url
		})}`));
	}

	public startGenerateQrCode = (options: {
		vendorCode: string;
		productCode: string;
		productVersion: string;
		productName: string;
		tenantCode: string;
		accountName: string;
		productUrl: string;
		logoImage: any;
		qrcodeSize: number;
		actionType?: string
	}): Promise<string> => {
		const { tenantCode, accountName, productUrl } = options;
		return new Promise((resolve, reject) => {
			QRCodeGenerator().then(async (lib: QRCodeGeneratorLib) => {
				try {
					let token = {};
					if (Ajax.isAuthorized()) {
						let res = await this.getHelpers()
							.getAjax()
							.get(`${Apis.DIRECT_ASK}${tenantCode}/${accountName}?validity=60`);
						if (res.body?.body) {
							token = res.body.body;
						}
					}
					this.generateQrPath(productUrl, token, lib, options).then(dataUrl => {
						resolve(dataUrl);
					}).catch(() => {
						reject();
					});
				} catch (e) {
					reject();
				}
			});
		});
	};
	private generateQrCode(
		path: string,
		token: { delegated?: string; authToken?: string },
		lib: QRCodeGeneratorLib,
		options: {
			vendorCode: string;
			productCode: string;
			productVersion: string;
			logoImage: any;
			qrcodeSize: number;
			tenantCode: string;
			actionType?: string
		}
	): Promise<string> {
		const { vendorCode, productCode, productVersion, logoImage, qrcodeSize, tenantCode, actionType } = options;
		path = path.replace('/mobile/policy/', `/mobile/policy-${vendorCode}/`.toLowerCase())
			.replace(':vendorCode', vendorCode)
			.replace(':productCode', productCode)
			.replace(':productVersion', productVersion)
			.replace(':tenantCode', tenantCode);
		let currentQs = Utils.fromQueryString();
		const qso = {} as { [propName: string]: string };
		if (Ajax.isAuthorized()) {
			qso.channel = encodeURIComponent(Envs.findAccount().organCode + '') // 'eShop-2A';
			qso.actionType = 'share';
		} else {
			const qs = Utils.fromQueryString();
			qso.theme = Envs.getCurrentTheme();
			qso.channel = encodeURIComponent(qs.vendor ? (qs.vendor + '') : (this.tenantCode === 'MEJ' ? 'MEJ.individual' : '')); // 'eShop-2A';
			qso.actionType = 'share';
		}

		const directQso = Utils.fromQueryString() as { [propName: string]: string };
		const directQsoString = Object.keys(directQso).filter(key => !['authFailTo'].includes(key)).map(key => `${key}=${directQso[key]}`).join('&');
		let baseUrl = `${process.env.REACT_APP_AJAX_CLIENT_CONTEXT_MALL}`;
		let mobileSignInUrl = window.location.origin + baseUrl + PATH.MALL_MOBILE_SIGN_IN;
		let mobileHomeUrl = window.location.origin + baseUrl + PATH.MALL_MOBILE_HOME;
		if (!Utils.isBlank(directQsoString)) {
			mobileHomeUrl = mobileHomeUrl + '?' + directQsoString;
		}

		qso.authFailTo = window.btoa(`${mobileSignInUrl}`);


		if (token.delegated && token.authToken) {
			qso.delegated = token.delegated;
			qso.ticket = token.authToken;
		}

		if (actionType) {
			qso.actionType = actionType;
		}
		if (currentQs.vendor) { // 企业链接
			qso.vendor = currentQs.vendor;
		}
		qso.rootUrlFrom = mobileHomeUrl;//toQueryString会转化，此处不用转换了
		path += (path.includes('?') ? '&' : '?') + Utils.toQueryString(qso);
		const location = window.location;
		path = `${location.protocol}//${location.host}/csms2${path}`;
		console.log(path)
		const handle = (resolve: Function, reject: Function, image: any): void => {
			const qrCodeSetting = {
				size: qrcodeSize,
				ecLevel: lib.ecLevel.LOW,
				minVersion: 8,
				background: '#fff',
				mode: image ? lib.modes.DRAW_WITH_IMAGE_BOX : undefined,
				radius: 0.5,
				image: image,
				mSize: 0.25
			};
			const element = document.createElement('CANVAS') as HTMLCanvasElement;
			const qrCode = new lib.qrcode(element) as QRCodeGeneratorFunc;
			qrCode
				.generate(path, qrCodeSetting)
				.then(() => {
					resolve(qrCode.getImage());
				})
				.catch(() => {
					reject();
				});
		};
		return new Promise((resolve, reject) => {
			if (logoImage) {
				var fileReader = new FileReader();
				fileReader.onloadend = () => {
					handle(resolve, reject, fileReader.result);
				};
				fileReader.readAsDataURL(logoImage);
			} else {
				handle(resolve, reject, undefined);
			}
		});
	}

	private generateQrPath(
		path: string,
		token: { delegated?: string; authToken?: string },
		lib: QRCodeGeneratorLib,
		options: {
			vendorCode: string;
			productCode: string;
			productVersion: string;
			logoImage: any;
			qrcodeSize: number;
			tenantCode: string;
			actionType?: string
		}
	): Promise<string> {
		const { vendorCode, productCode, productVersion, logoImage, qrcodeSize, tenantCode, actionType } = options;
		path = path.replace('/mobile/policy/', `/mobile/policy-${vendorCode}/`.toLowerCase())
			.replace(':vendorCode', vendorCode)
			.replace(':productCode', productCode)
			.replace(':productVersion', productVersion)
			.replace(':tenantCode', tenantCode);
		let currentQs = Utils.fromQueryString();
		const qso = {} as { [propName: string]: string };
		let vendor = currentQs.vendor;
		let organInSession = Storage.Last.session().get('organ');
		if (Ajax.isAuthorized()) {
			qso.channel = encodeURIComponent(Envs.findAccount().organCode + '') // 'eShop-2A';
			qso.actionType = 'share';
		} else {
			if (!vendor && organInSession?.organCode) vendor = organInSession?.organCode;
			qso.theme = Envs.getCurrentTheme();
			qso.channel = encodeURIComponent(vendor ? (vendor + '') : (this.tenantCode === 'MEJ' ? 'MEJ.individual' : '')); // 'eShop-2A';
			qso.actionType = 'share';
		}

		const directQso = Utils.fromQueryString() as { [propName: string]: string };
		const directQsoString = Object.keys(directQso).filter(key => !['authFailTo'].includes(key)).map(key => `${key}=${directQso[key]}`).join('&');
		let baseUrl = `${process.env.REACT_APP_AJAX_CLIENT_CONTEXT_MALL}`;
		let mobileSignInUrl = window.location.origin + baseUrl + PATH.MALL_MOBILE_SIGN_IN;
		let mobileHomeUrl = window.location.origin + baseUrl + PATH.MALL_MOBILE_HOME;
		if (!Utils.isBlank(directQsoString)) {
			mobileHomeUrl = mobileHomeUrl + '?' + directQsoString;
		}

		qso.authFailTo = window.btoa(`${mobileSignInUrl}`);


		if (token.delegated && token.authToken) {
			qso.delegated = token.delegated;
			qso.ticket = token.authToken;
		}

		if (actionType) {
			qso.actionType = actionType;
		}
		if (vendor || organInSession?.organCode) { // 企业链接
			qso.vendor = vendor || organInSession?.organCode;
		}
		qso.rootUrlFrom = mobileHomeUrl;//toQueryString会转化，此处不用转换了
		path += (path.includes('?') ? '&' : '?') + Utils.toQueryString(qso);
		const location = window.location;
		path = `${location.protocol}//${location.host}/csms2${path}`;
		console.log(path)
		return Promise.resolve(path);
	}

	protected stopInterval() {
		this.timer && clearInterval(this.timer);
	}
	protected startInterval(smsCount: number, callback?: any) {
		this.setState({
			canSend: false,
			count: smsCount
		});
		this.timer = setInterval(() => {
			let count = this.state.count;
			this.setState({
				count: --count,
				canSend: false
			});
			if (this.state.count === 0) {
				this.stopInterval();
				callback && callback();
				this.setState({
					count: smsCount,
					canSend: true
				});
			};
		}, 1000);
	}
	protected getPwdStrategy = async (tenantCode: string, fieldCheck: { [propName: string]: any }) => {
		try {
			let params = {
				tenantCode: tenantCode,
				configType: "PWD_STRATEGY", // 不在使用数字"1",使用英文字母组合
			};
			let res = await this.getHelpers().getAjax().post(Apis.TENANT_CONFIGURATION_LIST, params, { loading: true })
			if (res?.body?.body && res.body.body.length && res.body.body[0]?.configInfo.length) {
				let configInfo = (res.body.body[0].configInfo as any[]).find(item => item.accountType === '2'); // 2:前端用户 1:后端用户
				let securityInfo = configInfo?.security || {};
				if (Object.keys(securityInfo).length) {
					this.setState({
						pwdStrategy: { desc: securityInfo.pwdStrategyDescription }
					});
				}
			}
		} catch (e) {
			console.log('get password strategy desc error', e);
		}
	}
	updateAccountAndOrgInSession(accountInfo: any) {
		let keepCheckObj: { [propName: string]: any } = (keepCheckFieldInAccount as string[]).reduce((result, field) => {
			if (accountInfo.hasOwnProperty(field)) {
				// @ts-ignore
				result[field] = accountInfo[field];
			}
			return result;
		}, {});
		let accountInSession = Envs.findAccount();
		Envs.holdAccount({
			...accountInSession,
			...keepCheckObj,
			maskMobile: accountInfo.mobile
		});
		if (accountInfo.sourceType === '1') {
			accountInSession = Envs.findAccount();
			Envs.holdAccount({
				...accountInSession,
				showMall: true
			});
			Storage.Last.session().clear();
		} else {
			let organInSession = Storage.Last.session().get('organ');
			Storage.Last.session().set('organ', {
				...organInSession,
				organCode: accountInfo.organCode,
				organId: accountInfo.organizationId
			});
		}
		accountInSession = Envs.findAccount();
		if (!accountInSession.showMall && (window.location.href.includes(PATH.DESK2_PRODUCT_MAIN) || window.location.href.includes(PATH.DESK2_ENTERPRISE_EXCLUSIVE)) ||
			(accountInfo.sourceType === '1' && window.location.href.includes(PATH.DESK2_ENTERPRISE_EXCLUSIVE))) {
			this.getHelpers().getRouter().replaceRedirect(PATH.DESK2_HOME);
		}
	}
	getProductTags(list: any[] = []) {
		return list.reduce((res, item) => {
			if (item?.tags?.length) {
				(item.tags as any[]).forEach(tag => {
					let exist = (res as any[]).find(i => i.name === tag.tagName);
					if (!exist) {
						res.push({
							name: tag.tagName,
							code: tag.tagName
						});
					}
				});
			}
			return res;
		}, [{ code: '', name: '全部' }]).sort((itemA: any, itemB: any) => {
			return itemA.code - itemB.code
		});
	}
	getVendorNameTags(list: any[] = []) { // 处理供应商标签
		return list.reduce((res, item) => {
			let exist = (res as any[]).find(i => i.code === item.vendorId);
			if (!exist) {
				res.push({
					name: item.vendorAbbrName,
					code: item.vendorId
				});
			}
			return res;
		}, []).sort((itemA: any, itemB: any) => {
			return itemA.code - itemB.code
		});
	}

	protected triggerCaptcha(callback?: any, dialogOpts?: any) {
		const Row = Styled.div`
			display: flex; flex-wrap: wrap;&:not(:first-child) { margin-top: 10px;justify-content: center; }
			input { flex: 1; width: 150px; border: 1px solid ${props => props.theme.BORDER_COLOR_LIGHT}; }
			div { color: ${props => props.theme.COLOR_ERROR}; width: 100%; line-height: 1.5; }
		`
		let DialogContent = (props: { callback?: any }) => {
			let [captchaCode, setCaptchaCode] = useState<string>('');
			let [realCaptchaCode, setRealCaptchaCode] = useState<string>('');
			let [errMsg, setErrMsg] = useState<string>('');
			const captchaRef = useRef<any>(null);
			useEffect(() => {
				window.addEventListener('popstate',(state) => {
				 // 监听到返回事件，注意，只有触发了返回才会执行这个方法    
				 Dialog.hide(dialogRef);
			 }) 
				 return () =>  {
						 window.removeEventListener('popstate',(state) => {
							 Dialog.hide(dialogRef);
					 })   
				 }
			 })
			return <DeskPanel css={() => `padding: 10px 20px;`}>
				<Row>
					<StyledComponents.INPUT type="text" placeholder={'请输入图形验证码'} maxLength={4} name="captchaCode" value={captchaCode} onChange={evt => {
						const target = evt.target as HTMLInputElement;
						let value = target.value;
						setCaptchaCode(value);
					}} />
					<Captcha ref={captchaRef} onGetRightCode={(code: string) => {
						setRealCaptchaCode(code);
					}} width={100} style={{ marginLeft: '10px' }} />
					{errMsg ? <div>{errMsg}</div> : null}
				</Row>
				<Row>
					<DeskButton type={ButtonType.PRIMARY} onClick={async () => {
						if (realCaptchaCode !== captchaCode.toLowerCase()) {
							setErrMsg('请输入正确的图形验证码');
							captchaRef.current.refresh();
							return;
						} else {
							props.callback && props.callback(realCaptchaCode);
							Dialog.hide(dialogRef);
						}
					}}>确定</DeskButton>
				</Row>
			</DeskPanel>
		};
		let dialogRef = Dialog.show('图形验证码', <DialogContent callback={callback} />, null,
			{ boxCSS: { width: '400px', top: '30vh' }, grabQrCss: dialogOpts?.grabQrCss === undefined ? true : dialogOpts?.grabQrCss });
	}
	//图形验证码后端校验
	protected triggerCaptchaPic(callback?: any, dialogOpts?: any) {
		const Row = Styled.div`
			display: flex; flex-wrap: wrap;&:not(:first-child) { margin-top: 10px;justify-content: center; }
			input { flex: 1; width: 150px; border: 1px solid ${props => props.theme.BORDER_COLOR_LIGHT}; }
			div { color: ${props => props.theme.COLOR_ERROR}; width: 100%; line-height: 1.5; }
		`
		let DialogContent = (props: { callback?: any, src?: string ,num?: string }) => {
			let [captchaCode, setCaptchaCode] = useState<string>('');
			let [captchaCodeSrc, setCaptchaCodeSrc] = useState(()=>{
				return props.src  });
			let [errMsgTimes, setErrMsgTimes] = useState(()=>{
				return props.num
			});
			const captchaRef = useRef<any>(null);
			useEffect(() => {
				window.addEventListener('popstate',(state) => {
				 // 监听到返回事件，注意，只有触发了返回才会执行这个方法    
				 Dialog.hide(dialogRef);
			 }) 
				 return () =>  {
						 window.removeEventListener('popstate',(state) => {
							 Dialog.hide(dialogRef);
					 })   
				 }
			 })
			return <DeskPanel css={() => `padding: 10px 20px;`}>
				<Row>
					<StyledComponents.INPUT type="text" placeholder={'请输入图形验证码'} maxLength={4} name="captchaCode" value={captchaCode} onChange={evt => {
						const target = evt.target as HTMLInputElement;
						let value = target.value;
						setCaptchaCode(value);
					}} />
					<img src={captchaCodeSrc} onClick={async () => {
						let params: {[propName: string]: any} = {
							tenantCode: this.tenantCode,
							mobile: this.state.mobile
						};
						let res = await this.getHelpers().getAjax().post(Apis.REFRESH_PIC_CODE, params, { loading: true });
						setCaptchaCodeSrc(res?.body?.body?.message);
						setErrMsgTimes(res?.body?.body?.result)
						return;
					}} width={100} style={{ marginLeft: '10px' }} />	
					<div>输错3次账号锁定，剩余{errMsgTimes}次机会</div>
				</Row>
				<Row>
					<DeskButton type={ButtonType.PRIMARY} onClick={async () => {
						if (!captchaCode) {
							Alert.error("请输入图形验证码");
							return Promise.reject();
						}
						let params: {[propName: string]: any} = {
							tenantCode: this.tenantCode,
							mobile: this.state.mobile,
							imageVerificationCode: captchaCode
						};
						let check = await this.getHelpers().getAjax().post(Apis.VERIFY_PIC_CODE, params, { loading: true });
						const res = check?.body?.body;
                        if (res.code === 'lock' || res.code === 'pass' || res.code === 'lock-startup') {
							if (res.code === 'pass') {
								props.callback && props.callback(captchaCode);
							}
                            if (res.code === 'lock') {
								const message = res.message;
								if(!Utils.isBlank(message)){
									Alert.error(message).then(()=>{
										Dialog.hide(dialogRef);
									});
								}else{
									Alert.error("账号已锁定，点击“忘记密码”去重置").then(()=>{
										Dialog.hide(dialogRef);
									});
								}
								return;
							}
							if (res.code === 'lock-startup') {
                                Alert.error("您的账号暂未设置登录密码，为了您的账号安全，请先前往设置密码。").then(() => {
									Dialog.hide(dialogRef);
									let organQuery = Storage.Last.session().get('organQuery');
									let redirectPath = organQuery?.originVendor ? `${PATH.DESK2_RESET_PASSWORD_VENDOR.replace(':vendor', encodeURIComponent(organQuery.originVendor))}` : PATH.DESK2_RESET_PASSWORD;
									Storage.clear();
									this.getHelpers().getRouter().pushRedirect(redirectPath);
								});
								return;
                            }
                            Dialog.hide(dialogRef);
                        } else {
                            this.getHelpers().getAjax().post(Apis.REFRESH_PIC_CODE, params, { loading: true }).then((refresh: any) => {
                                const refreshRes = refresh?.body?.body;
                                setCaptchaCodeSrc(refreshRes.message);
                                setErrMsgTimes(refreshRes.result); // 20221209 david从code改为result
                            });
                        }
					}}>确定</DeskButton>
				</Row>
			</DeskPanel>
		};
		let dialogRef = Dialog.show('图形验证码', <DialogContent callback={callback} src={dialogOpts.src} num={dialogOpts.num}/>, null,
			{ boxCSS: { width: '400px', top: '30vh' }, grabQrCss: dialogOpts?.grabQrCss === undefined ? true : dialogOpts?.grabQrCss });					
	}
	async init() {
		try {
			let organInSession = Storage.Last.session().get('organ');
			let organQuery = Storage.Last.session().get('organQuery');
			let qs = Utils.fromQueryString();
			let _vendor = this._vendor;
			if (!qs.vendor && organQuery?.originVendor && organQuery.originVendor !== _vendor) {
				Storage.Last.session().clear();
			}
			// 企业用户进入页面自带查询参数vendor与ticket
			if (qs.vendor || _vendor) { //  && qs.ticket
				if (qs.vendor && organInSession?.organCode && organInSession?.organCode !== qs.vendor) {
					// Storage.clear();
					Storage.Last.session().clear();
				}
				let res = await this.getHelpers().getAjax().get(Apis.ORGAN_QUERY, {
					organCode: qs.vendor || _vendor
					// signedCode: qs.ticket
				});
				// if (!Ajax.isAuthorized()) {
				if (res?.body?.body) {
					Storage.Last.session().set('organ', {
						...organInSession,
						...res.body.body
					});
					Storage.Last.session().set('organQuery', {
						originVendor: _vendor,
						vendor: res.body.body?.organCode
						// ticket: qs.ticket
					});
				}
				organInSession = Storage.Last.session().get('organ');
				if (res?.body?.body.hasOwnProperty('showMall')) {
					let accountInSession = Envs.findAccount();
					Envs.holdAccount({
						...accountInSession,
						showMall: res.body.body.showMall
					});
				}
				// }
			}
			organInSession = Storage.Last.session().get('organ');
			if (Ajax.isAuthorized()) {
				let res = await this.getHelpers().getAjax().get(Apis.QUERY_ACCOUNT_MASK, {});
				if (res?.body?.body) {
					qs = Utils.fromQueryString();
					let accountInfo = res.body.body;
					if (qs.vendor && accountInfo.sourceType === '1') {
						delete qs.vendor;
						Storage.Last.session().clear();
						window.location.replace(window.location.href.split('?')[0] + (Object.keys(qs).length ? `?${Utils.toQueryString(qs)}` : ''));
						return;
					} else if (/2|3/.test(accountInfo.sourceType) && (accountInfo.organCode !== organInSession?.organCode || accountInfo.organCode !== qs.vendor) && qs.vendor) {
						delete qs.vendor;
						if (qs && JSON.stringify(qs) !== '{}')
							window.location.replace(window.location.href.split('?')[0] + `?${Utils.toQueryString({ ...qs })}`);
						return;
					} else {
						this.updateAccountAndOrgInSession(res.body.body);
					}
				}
			}
			let params: { [propName: string]: any } = {
				tenantCode: this.tenantCode,
				configType: "SALES_CONFIG", // 不在使用数字"3",使用英文字母组合
				status: 1
			};
			if (organInSession?.organCode) {
				// console.log(organInSession.organCode);
				params.organCode = organInSession.organCode;
				let organRes = await this.getHelpers().getAjax().post(Apis.TENANT_CONFIGURATION_LIST, params);
				if (organRes?.body?.body && organRes.body.body.length) {
					let configList: { [propName: string]: any }[] = organRes.body.body;
					let entObj = Utils.getConfigFromRes(configList, { detailConfigType: '5', isOgran: true });
					if (entObj?.list && entObj.list.length) {
						let obj = entObj.list[0];
						Storage.Last.session().set('organ', {
							...organInSession,
							logo: obj.logo1 || '',
							colorTheme: obj.colorTheme1 || '2' // 顶部UI配色根据企业Logo可切换深色（1）、浅色（2）两种，默认为浅色
						});
					}
				} else {
					Storage.Last.session().set('organ', {
						...organInSession,
						logo: '',
						colorTheme: '2' // 顶部UI配色根据企业Logo可切换深色（1）、浅色（2）两种，默认为浅色
					});
				}
			}
			this.reRenderHeader();
		} catch (e) {
			//@ts-ignore
			if (e?.body?.errors && e.body.errors.length) {
				//@ts-ignore
				if (e.body.errors[0].code === 'ORGAN_NOT_EXISTED') {
					Alert.error('机构不存在');
					//@ts-ignore
				} else if (e.body.errors[0].code === 'ORGAN_IS_INVALID') {
					Alert.hide();
					let toNormalLink = () => {
						Storage.clear();
						Storage.Last.session().clear();
						window.location.href = `${window.location.protocol}//${window.location.host}${process.env.REACT_APP_AJAX_CLIENT_CONTEXT}${PATH.DESK2_HOME}`;
					}
					let dialogRef = Dialog.show('', <DeskPanel css={() => `line-height: 24px;margin: 10px 0 20px 0;text-align:center;`}>
						{
							//@ts-ignore
							e.body.errors[0].description
						}
					</DeskPanel>,
						<DeskButton
							type={ButtonType.PRIMARY}
							label="确认" css={() => `margin-top: 20px;width: 150px;`}
							onClick={() => {
								Dialog.hide(dialogRef);
								toNormalLink();
							}}
						/>, {
						boxCSS: { width: '400px', padding: '40px' },
						closeBtn: true
					});
				}
			}
		}
	}
	loadCookieManager() {
		// <div id="consent-banner"></div>  
		// <script type="text/javascript" async="async" src="https://consent.trustarc.com/v2/notice/kys3l2&locale=ZH_HANS"></script>
		if (!document.getElementById('consent-banner') && window.location.host.includes('mej.cn')) {
			const bannerDiv = document.createElement('div');
			bannerDiv.id = 'consent-banner';
			const script = document.createElement('script');
			script.type = 'text/javascript';
			script.async = true;
			script.src = '//consent.trustarc.com/v2/notice/kys3l2?locale=ZH_HANS';
			document.body.append(bannerDiv);
			document.body.append(script);
		}
	}
    loadBaiduAnalysis() {
        if (!document.getElementById('baidu-analysis') && /www.mej.cn|uat.mej.cn/.test(window.location.host)) {
			const key = window.location.host.includes('www.mej.cn') ? '500de63558f70f32da6c3549bb123eee' : '0c873d263ab9c0a14fb9f3fa2837b499';
            const script = document.createElement('script');
            script.id = 'baidu-analysis';
            script.type = 'text/javascript';
            script.async = true;
            script.src = `//hm.baidu.com/hm.js?${key}`;
            document.body.append(script);
        }
    }
	async componentDidMount(): Promise<void> {
		await this.init();
		// TODO: 根据url初始化theme
		if (this.tenantCode === 'MEJ') {
			Envs.application()!.changeTheme('mej');
			this.loadCookieManager();
			this.loadBaiduAnalysis();
		}
	}
}

export default DeskPage;
